import Vue from 'vue'
import router from '@/router'
import moment from 'moment'
import toast from '@/utils/toast'
import vuetify from '@/plugins/vuetify'
import apiFactory from '@/api'
import store from '@/store'

// Globally register all `Base`-prefixed components
import '@/components/_globals'

import App from './App'

// Service Worker
import { registerServiceWorker } from './serviceWorker'

// Vue Froala
// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min.js')
require('froala-editor/js/plugins.pkgd.min.js')

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'

Vue.use(VueFroala)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.prototype.$api = apiFactory
Vue.prototype.$moment = moment
Vue.prototype.$toast = toast

if (!process.env.VUE_APP_SSO_URL) {
  throw new Error('Please add VUE_APP_SSO_URL in your environment variables.')
}

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')

registerServiceWorker()
